import { render, staticRenderFns } from "./StudentLeaveSubApplication.vue?vue&type=template&id=775282d2&scoped=true&"
import script from "./StudentLeaveSubApplication.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubApplication.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubApplication.vue?vue&type=style&index=0&id=775282d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775282d2",
  null
  
)

export default component.exports